import { Icon } from '../Icon';

const InputIcon2 = Icon;

export { InputIcon2 };
